import * as React from 'react';
import { render } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';

import * as style from './style.css';

import { IModerationConstraintPopupProps, ModerationConstraintPopup } from './moderation-constraint-popup';

export const renderModerationConstraintPopup = (container: Element, props: IModerationConstraintPopupProps): void => {
  if (window.location.pathname === '/verification/') {
    return;
  }

  // Готовим подложку для модального окна
  container.classList.add(style['fade']);
  const body = document.querySelector('body');
  let bodyOverflowY = '';
  if (body && body.style) {
    bodyOverflowY = body.style.overflowY || '';
    body.style.overflowY = 'hidden';
  }

  const stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  const onClose = (e: React.MouseEvent<HTMLElement>) => {
    container.classList.remove(style['fade']);
    if (body && body.style) {
      body.style.overflowY = bodyOverflowY;
    }
    props.onClose(e);
    stopPropagation(e);
  };

  const onCancel = (e: React.MouseEvent<HTMLElement>) => {
    props.onCancel(e);
    onClose(e);
  };

  render(
    <ErrorLogComponent logger={getLogger()}>
      <ModerationConstraintPopup
        {...props}
        // tslint:disable-next-line:no-unnecessary-callback-wrapper
        onCancel={(event: React.MouseEvent<HTMLElement>) => onCancel(event)}
        // tslint:disable-next-line:no-unnecessary-callback-wrapper
        onClose={(event: React.MouseEvent<HTMLElement>) => onClose(event)}
      />
    </ErrorLogComponent>,
    container,
  );
};
